module.exports = __webpack_public_path__ + "img/tx-_0000s_0007_8.53773d23.png";